
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Alert from 'vux/src/components/alert/index.vue'

import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
export default {
name: "complaintCollect",
components:{
XImg,
Group,
Flexbox,
FlexboxItem,
Alert,
global,
loadPage
},
data(){
return{
picheight:window.screen.width * 0.22 - 8,
show2:false,
dataList:{},
allId:"",
srcs:"",
msid:"",
text_1:""
}
},
updated:{
showAlert:function(src){
alert("dsfdsfdsf")

this.show2 = true
this.srcs = "";
}
},
beforeMount (){
this.show_1 = true;
if(this.$router.history.current.path == "/complaintCollect"){
document.title = "我的建议";
}
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
if(res.body.result) {
let data = res.body.result[0];
this.getRepairList(data);
this.show_1 = false;
}
},function(err){
console.log(err)
})

},
methods:{
getRepairList(paramData){
let phones = this.$router.history.current.query.phone;
let sData = "comncode="+paramData.comn_code+"&hscode="+paramData.hsNo+ "&hsphone="+phones;
this.$http.get(global.host + '/comp/findselfcomppro?'+sData).then(function(res){
let datay = res.body.result;
this.dataList = new Object();
this.allId = new Object();
for(let ks in datay){
if(typeof(ks) == "object"){
for(let ms in ks){
this.dataList[ms] = ks[ms];
}
}else{
this.dataList[ks] = datay[ks];
let sId = datay[ks].feedbackId;
this.$http.get(global.host + '/repair/findPictureById?repairId='+sId).then(function(res){//v-on:click=\"showAlert("+rpic[ms].repairPic+")\"
let rpic = res.body.result;
var rows = "";

for(let ms in rpic){
rows += "<flexbox-item style=\'margin-right:8px\'><img id ='"+ rpic[ms].repairId+"' style=\"height:70px;width:70px\" onclick=\"document.getElementById('showAlertLayer').style.display='table';document.getElementById('preViewImg').src=\'"+rpic[ms].repairPic+"\';\" src=\'"+rpic[ms].repairPic+"\'></flexbox-item>";
}
document.getElementById("mts"+sId).innerHTML = rows;

},function(err){
console.log(err)
})
}
}
},function(err){
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/complaintComponenst/complaintCollect.vue